import { render, staticRenderFns } from "./table-card.vue?vue&type=template&id=2b4b7be8&scoped=true&"
import script from "./table-card.vue?vue&type=script&lang=ts&"
export * from "./table-card.vue?vue&type=script&lang=ts&"
import style0 from "./table-card.vue?vue&type=style&index=0&id=2b4b7be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b7be8",
  null
  
)

export default component.exports